import { Data } from "@angular/router";

export class SexualityEnum {
	
    public static readonly ABSENT: Data = { id: 1, name: "lblAbsent" };
    public static readonly REGULAR: Data = { id: 2, name: "lblRegular" };
    public static readonly IRREGULAR: Data = { id: 3, name: "lblIrregular" };

    public static getSexualityList() {
        return [SexualityEnum.ABSENT, SexualityEnum.REGULAR, SexualityEnum.IRREGULAR];
    }
}